import script from "./pagination.vue?vue&type=script&setup=true&name=pagination&lang=js"
export * from "./pagination.vue?vue&type=script&setup=true&name=pagination&lang=js"

const __exports__ = script;

export default __exports__